import Record from '../Record'

export default class AEE extends Record {

	constructor (data) {
		super(data)
		return this._proxy
	}

	static async fetch (id = null) {
		if (id == null) {
			// Create record
			return new AEE({
				id: null,
				ap: '',
				link: 'company',
				company_id: null,
				terminal_id: null,
				notes: '',
				last_inspection_d: null,
				licence: null,
				licence_to_upload: null
			})
		} else {
			// Load
			let data = await Anvil.REST.get(`/c_order/aee/${id}`)
			data.link = data.terminal_id ? 'terminal' : 'company'
			if (typeof data.state === 'string') {
				data.state = JSON.parse(data.state)
			}
			if (data.state && data.state.lic) {
				data.licence = data.state.lic
			}
			return new AEE(data)
		}
	}

	static async delete (id) {
        await Anvil.REST.delete(`/c_order/aee/${id}`)
	}

	async commit () {

		// Validate
		if (!this.validate()) {
			throw new Error('Kérjük ellenőrizze a megadott adatokat.')
		}

		const data = { ...this._data }
		delete data.state
		delete data.state_dt

		if (data.id == null) {
			// Insert
			const res = await Anvil.REST.post(`/c_order/aee`, data)
			this._data.id = res.insertId
		} else {
			// Update
			await Anvil.REST.put(`/c_order/aee/${data.id}`, data)
		}
	}

	validation_schema = {
		ap: [ 'required' ],
		link: [ 'required' ],
		company_id: [ 'required' ]
	}
}